import React from "react";
import { Link } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { useI18n } from "../lib/i18n.jsx";
import { PageHeader } from "../components/Bits";
import { Users, Building2, FileText, BarChart3, Clock, Target, ChevronRight } from "lucide-react";

const TILES = [
  { to: "/employees", key: "employees", icon: Users, perm: "employees.view" },
  { to: "/projects", key: "projects", icon: Building2, perm: "projects.view" },
  { to: "/reports", key: "reports", icon: FileText, perm: "reports.view" },
  { to: "/analytics", key: "analytics", icon: BarChart3, perm: "analytics.view" },
  { to: "/worktime", key: "worktime", icon: Clock, perm: "worktime.view" },
  { to: "/plan-fact", key: "plan_fact", icon: Target, perm: "analytics.view" },
];

export default function Dashboard() {
  const { t } = useI18n();
  const { can, user } = useAuth();
  const tiles = TILES.filter((x) => can(x.perm));

  return (
    <div data-testid="home-page">
      <PageHeader title={t("home")} subtitle={user?.company?.name || ""} />
      <div className="grid grid-cols-2 lg:grid-cols-3 gap-3">
        {tiles.map(({ to, key, icon: Icon }) => (
          <Link key={key} to={to} data-testid={`home-tile-${key}`}
            className="tactical-card p-5 flex items-center gap-4 min-h-[96px] transition-[transform,background-color] hover:-translate-y-0.5 active:scale-[0.98] group">
            <div className="h-11 w-11 rounded-lg bg-[var(--amber)]/15 text-[var(--amber)] flex items-center justify-center shrink-0">
              <Icon size={22} />
            </div>
            <div className="font-display font-bold text-base lg:text-lg flex-1">{t(key)}</div>
            <ChevronRight size={18} className="text-[var(--text-3)] group-hover:translate-x-0.5 transition-transform" />
          </Link>
        ))}
      </div>
    </div>
  );
}
